// Modal cấu hình TỰ ẨN bài khỏi feed Kênh cộng đồng sau N ngày kể từ lúc đăng.
// Mặc định 30 ngày, 0 = tắt. Bài ghim + bài của admin không bị ẩn; ẩn cả feed, Đã lưu và link chi tiết (trừ admin/mod).
// Không xoá bài -> giảm số ngày hoặc tắt là bài cũ hiện lại ngay.
import React, { useEffect, useState } from "react";
import { Modal, InputNumber, message, Alert } from "antd";
import communityApi from "../../../api/communityApi";

export default function CommunityHideDaysModal({ open, onClose, onSaved }) {
    const [days, setDays] = useState(null);
    const [range, setRange] = useState({ min: 0, max: 365 });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                setLoading(true);
                const { data } = await communityApi.getHideDays();
                const cfg = data?.data || {};
                setDays(cfg.days ?? 30);
                setRange({ min: cfg.min ?? 0, max: cfg.max ?? 365 });
            } catch {
                message.error("Không thể tải cấu hình tự ẩn bài");
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    const handleSave = async () => {
        if (!Number.isInteger(days) || days < range.min || days > range.max) {
            message.error(`Vui lòng nhập số từ ${range.min} đến ${range.max}`);
            return;
        }
        try {
            setSaving(true);
            await communityApi.updateHideDays(days);
            message.success(days > 0 ? `Đã lưu: tự ẩn bài sau ${days} ngày` : "Đã tắt tự ẩn bài");
            onSaved?.(days);
            onClose();
        } catch {
            message.error("Không thể lưu cấu hình");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title="Tự ẩn bài cũ khỏi feed"
            open={open}
            onOk={handleSave}
            onCancel={onClose}
            okText="Lưu"
            cancelText="Đóng"
            confirmLoading={saving}
        >
            <Alert
                type="info"
                showIcon
                className="mb-3"
                message="Bài đăng quá số ngày này sẽ không hiện trên Kênh cộng đồng (web + app). Bài đang ghim và bài do admin đăng (thông báo...) luôn hiện, chỉ ẩn bài của CTV/người dùng. Link chi tiết và mục Đã lưu cũng không mở được (admin/mod vẫn xem được). Bài không bị xoá: giảm số ngày hoặc nhập 0 là bài hiện lại. Áp dụng sau khoảng 30 giây."
            />
            <InputNumber
                className="w-full"
                min={range.min}
                max={range.max}
                precision={0}
                value={days}
                onChange={setDays}
                disabled={loading}
                addonAfter="ngày (0 = tắt)"
            />
        </Modal>
    );
}
